module.exports = __webpack_public_path__ + "assets/carrers-splash-02.jpg";